<template>
  <div class="popup">
    <h4 class="popup__title middle">Расшифровка зарплатного отчета</h4>
    <div class="popup__content">
      <div class="period decoding-select">
        <span class="date-picker-label">Менеджер</span>
        <v-select
          :options="managerOptions"
          label="name"
          v-model="manager"
          placeholder="Выберите менеджера"
          @search="fetchOptionsManager"
          :clearable="false"
        >
          <template #no-options>Введите имя пользователя</template>
        </v-select>
      </div>
      <div class="period">
        <span class="date-picker-label">Выбрать период</span>
        <VueDatePicker
          input-class-name="month-picker"
          v-model="date"
          month-picker
          :enable-time-picker="false"
          :format="format"
          locale="ru"
          cancelText="Отмена"
          selectText="Выбрать"
          :clearable="false"
        >
          <template #input-icon>
            <img class="input-slot-image" src="../../assets/datepicker-icon.svg" alt="d" />
          </template>
        </VueDatePicker>
      </div>
      <div class="period decoding-select">
        <span class="date-picker-label">Клиент</span>
        <v-select
          :options="customerOptions"
          label="name"
          v-model="customer"
          placeholder="Выберите клиента"
          @search="fetchOptionsCustomer"
          :clearable="false"
        >
          <template #no-options>Введите имя пользователя</template>
        </v-select>
      </div>
      <div class="period decoding-select">
        <span class="date-picker-label">ВИНК</span>
        <v-select
          :options="fuelProviders"
          label="name"
          v-model="provider"
          placeholder="Выберите ВИНК"
          :clearable="false"
        >
          <template #no-options>Введите имя</template>
        </v-select>
      </div>
      <div class="period decoding-select">
        <span class="date-picker-label">Тип топлива</span>
        <v-select
          :options="fuelTypes"
          label="name"
          v-model="fuelType"
          placeholder="Выберите тип топлива"
          @search="fetchOptionsCustomer"
          :clearable="false"
        >
          <template #no-options>Введите имя</template>
        </v-select>
      </div>
    </div>
    <div class="actions">
      <button class="button btn-primary" @click="closeAll()">Закрыть</button>
      <button class="button btn-primary" @click="downloadReport()" :disabled="setDisabled || localLoading">
        <Loader v-if="localLoading" />
        Скачать
      </button>
    </div>
  </div>
</template>

<script>

import {popups} from '@/mixins/popups'
import {mapActions, mapState} from "vuex";
import VueDatePicker from '@vuepic/vue-datepicker'
import vSelect from 'vue-select'

export default {
  name: "salaryReportDecodingPopup",
  mixins: [popups],
  data() {
    return {
      date: null,
      manager: null,
      customer: null,
      provider: null,
      fuelType: null,
      managerArr: null,
      customerArr: null,
      localLoading: false
    }
  },
  computed: {
    ...mapState({
      managers: (state) => state.admin.managers,
      fuelProviders: (state) => state.user.fuelProviders,
      fuelTypes: (state) => state.user.fuelTypes,
    }),
    setDisabled() {
      return this.date === null || this.manager === null || this.customer === null || this.provider === null || this.fuelType === null;
    },
    managerOptions() {
      let newArr = []
      if (this.managerArr && this.managerArr.length > 0) {
        this.managerArr.forEach((item) => {
          newArr.push({
            id: item.manager_id,
            name: item.name
          })
        })
      }
      return newArr
    },
    customerOptions() {
      let newArr = []
      if (this.customerArr && this.customerArr.length > 0) {
        this.customerArr.forEach((item) => {
          newArr.push({
            id: item.customer_id,
            name: item.name
          })
        })
      }
      return newArr
    },
  },
  methods: {
    ...mapActions({
      getSalaryReportDecoding: 'getSalaryReportDecoding',
      getUsersSearch: 'getUsersSearch',
    }),
    async fetchOptionsManager(search, loading) {
      if (search.length >= 3) {
        loading(true)

        await this.getUsersSearch({
          search,
          type: 2
        }).then(() => {
          this.managerArr = this.managers
        })
        loading(false)
      }
    },
    async fetchOptionsCustomer(search, loading) {
      if (search.length >= 3) {
        loading(true)

        await this.getUsersSearch({
          search,
          type: 3
        }).then(() => {
          this.customerArr = this.managers
        })
        loading(false)
      }
    },
    async downloadReport() {
      this.localLoading = true
      let data = {
        month: this.date.month + 1,
        year: this.date.year,
        manager: this.manager,
        customer: this.customer,
        provider: this.provider,
        fuel_type: this.fuelType
      }
      await this.getSalaryReportDecoding(data)
      this.localLoading = false
    }
  },
  async mounted() {
    let date = new Date()
    let month = date.getMonth()
    let year = date.getFullYear()
    if (month === 0) {
      month = 11
      year = Number(year) - 1
    }
    this.date = {
      month,
      year
    }
  }
}
</script>
<script setup>

import Loader from "@/components/common/Loader.vue";

const format = (date) => {
  let options = { year: 'numeric', month: 'long' }
  return `${date.toLocaleString('ru-RU', options)}`
    .replace('г.', '')
    .replace(/(?:^|\s|["'([{])+\S/g, (match) => match.toUpperCase())
}
</script>

<style lang="scss">
@import '../../styles/variables';
.decoding-select {
  .v-select {
    width: 100%;
  }
}
</style>

<style scoped lang="scss">
@import "../../styles/variables";

.popup {
  :deep(.loader) {
    height: 200%;
    width: 200%;
    left: -50%;
    top: -50%;
    border-radius: 25px;
    transform: scale(0.5);
    svg {
      position: unset;
    }
  }
}

.popup__subtitle {
  max-height: 70vh;
  overflow-y: auto;
}

.popup__content {
  width: 100%;

  .period {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 15px;

    & > span {
      margin-bottom: 5px;
    }
  }
}
</style>
